import { ref } from "vue";

const initial = ref(true);

export default initial;